import { useCurrencyStore } from "~/stores/currencyStore";

const fx = new fxm(typeof window === "undefined" ? {} : window);
// export const PRICE_PER_NIGHT_TAX = 'pricePerNightI'
// export const PRICE_PER_NIGHT_NO_TAX = 'pricePerNightE'
// export const PRICE_PER_STAY_TAX = 'pricePerStayI'
// export const PRICE_PER_STAY_NO_TAX = 'pricePerStayE'
export const PRICE_PER_NIGHT_TAX = "pricePerNightInclTax";
export const PRICE_PER_NIGHT_NO_TAX = "pricePerNightExclTax";
export const PRICE_PER_STAY_TAX = "pricePerStayInclTax";
export const PRICE_PER_STAY_NO_TAX = "pricePerStayExclTax";

export const setRates = (rates) => {
  fx.rates = rates;
};

export const setPriceBase = (base) => {
  fx.base = base || "USD";
};

export const convertPrice = (price, from, to) => {
  const fxWrapper = fx(price);
  return fxWrapper.from(from).to(to);
};

export const formatPrice = (value, currency, disableFractionDigits = false) => {
  let locale = "en-US";

  // TODO: refactor this into a composable so useI18n can be used throughout the app
  if (getCurrentInstance()) {
    const { locale: language, locales } = useI18n();

    locale =
      locales.value.find((locale) => locale.code === language.value)
        ?.language || "en-US";
  }

  let relevantCurrency = currency;

  if (currency === "local") {
    const currencyStore = useCurrencyStore();
    relevantCurrency = currencyStore.hotelOfferCurrency;
  }

  let formatterOptions = {
    style: "currency",
    currency: relevantCurrency || "EUR",
    useGrouping: false,
  };
  if (disableFractionDigits) {
    formatterOptions.minimumFractionDigits = 0;
    formatterOptions.maximumFractionDigits = 0;
    formatterOptions.roundingMode = "floor";
  }
  const formatter = new Intl.NumberFormat(locale, formatterOptions);

  // Ctzmn wants a space between currency and price ...
  let formattedValue = formatter.format(value);

  // debugger;
  // Check if the formatted value starts with a currency symbol and does not have a space
  const startsWithCurrencySymbol = formattedValue.match(/^[^\d]+/);
  if (startsWithCurrencySymbol && !startsWithCurrencySymbol[0].endsWith(" ")) {
    formattedValue = formattedValue.replace(
      /^[^\d]+/,
      `${startsWithCurrencySymbol[0]} `,
    );
  }

  return formattedValue; //formatter.format(value); /* $2,500.00 */
};

/**
 * Better price formatting
 * when it comes to disableFractionDigits
 *
 * @param {float} value
 * @param {string} currency
 * @param {boolean} disableFractionDigits
 * @returns {string}
 */
export const formatPrices = (
  value,
  currency,
  disableFractionDigits = false,
) => {
  let locale = "en-US"; // get from json or ...
  // let currency = this.$root?.appConfig?.currency || 'USD'; // get from json or ...
  locale = locale || undefined;

  let relevantCurrency = currency;

  if (currency === "local") {
    const currencyStore = useCurrencyStore();
    relevantCurrency = currencyStore.hotelOfferCurrency;
  }

  let formatterOptions = {
    style: "currency",
    currency: relevantCurrency || "EUR",
    useGrouping: false,
  };
  const formatter = new Intl.NumberFormat(locale, formatterOptions);

  // Ctzmn wants a space between currency and price ...
  let formattedValue = formatter.format(value);

  // Only non decimal digits needed?
  if (disableFractionDigits) {
    formattedValue = formattedValue.split(".")[0] || formattedValue;
  }

  // debugger;
  // Check if the formatted value starts with a currency symbol and does not have a space
  const startsWithCurrencySymbol = formattedValue.match(/^[^\d]+/);
  if (startsWithCurrencySymbol && !startsWithCurrencySymbol[0].endsWith(" ")) {
    formattedValue = formattedValue.replace(
      /^[^\d]+/,
      `${startsWithCurrencySymbol[0]} `,
    );
  }

  return formattedValue; //formatter.format(value); /* $2,500.00 */
};
